import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import React from 'react';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectInvoices } from '../../Invoices/selectors';
import { selectVehicle } from '../../Vehicles/selectors';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_PRODUCT_INVOICES } from '../../Invoices/constants';
import { REQUEST_VEHICLE } from '../../Vehicles/constants';
import {deleteProductInvoice, fetchInvoice, fetchProductInvoices} from '../../Invoices/actions';
import { fetchVehicle } from '../../Vehicles/actions';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import {Times} from "../../../components/Icon";
import {InvoiceFinalizationStatusBar} from "../../Invoices/components/InvoiceFinalizationStatusBar";

const Container = styled.div`
  width: 100%;
  background: white;
  margin-bottom: 30px;
`;

const Row = styled.div`
  border: solid 1px;
  //margin-top: 4px;
  margin-bottom: 8px;
  width: auto;
  padding: 0 5px;
  .row-title {
    margin-left: 5px;
    font-size: 18px;
  }
`;

export class ProductInvoiceTableComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  tofn(url) {
    return event => {
      this.to(url, event?.ctrlKey || event?.metaKey);
    };
  }

  render() {
    return (
      <Container>
        <h4>{this.props.header}</h4>
        {this.props.invoices.map(i => this.renderRow(i, this.props.direction, this.props.vehicleId))}
      </Container>
    );
  }

  renderRow(invoice, direction, vehicleId) {
    const showFinalizationStatusBar = invoice.finalizationStatus && (invoice.finalizationStatus !== "DONE")
    return (
      <Row>
        <HBox vCenter>
          <div
            className="row-title"
            onClick={() => {
              this.to(`/invoices/product-invoices/vehicle/${vehicleId}/invoice/${invoice.id}`);
            }}
          >
            Invoice {invoice.id}
          </div>
          {showFinalizationStatusBar && <InvoiceFinalizationStatusBar
            disableStatusMsg={true}
            invoice={invoice}
          />}
          <Button onClick={() => this.props.delete(invoice.id)} small isPrimary>
            {invoice.isFinal ? 'pdf' : <Times/>}
          </Button>
        </HBox>
      </Row>
    );
  }
}

ProductInvoiceTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    // invoices: selectInvoices(),
    vehicle: selectVehicle(ownProps.vehicleId),
    work: selectWorks([REQUEST_PRODUCT_INVOICES, REQUEST_VEHICLE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchProductInvoices(ownProps.vehicleId, ownProps.direction));
    },
    fetchVehicle: () => {
      dispatch(fetchVehicle(ownProps.vehicleId));
    },
    fetchInvoice: () => {
      dispatch(fetchInvoice(ownProps.invoice.id))
    },
    delete: (invoiceId) => {
      dispatch(deleteProductInvoice(invoiceId, ownProps.vehicleId, ownProps.direction))
    }
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ProductInvoicesTable = compose(
  withConnect,
  withRouter,
  injectIntl,
)(ProductInvoiceTableComp);
